// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-52401300] {\n  font-size: 12px;\n  color: #999;\n}\n[data-v-52401300] .el-input--medium,[data-v-52401300].ivu-input {\n  font-size: 12px !important;\n}\n.c_row-item[data-v-52401300] {\n  margin-bottom: 20px;\n}\n.slider-box[data-v-52401300] .el-input__suffix {\n  top: 10px !important;\n}\n.label[data-v-52401300] {\n  font-size: 12px;\n  font-family: PingFang SC-Regular, PingFang SC;\n  font-weight: 400;\n  color: #999999;\n}", ""]);
// Exports
module.exports = exports;
